import { render, staticRenderFns } from "./buy-quote-edit-form.html?vue&type=template&id=36a5fe66&scoped=true&"
import script from "./buy-quote-edit-form.js?vue&type=script&lang=js&"
export * from "./buy-quote-edit-form.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a5fe66",
  null
  
)

export default component.exports